import { createStyles, makeStyles } from '@material-ui/core/styles';
import { $semiBold, $30pt } from '../styles/Variables';

export const useStyles = makeStyles(() =>
  createStyles({
    textField__root: {
      fontWeight: $semiBold,
      fontSize: $30pt,
      color: '#000000',
    },
    inputStyle: {
      textAlign: 'center',
    },
  })
);
